import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useDeletePodcastTicket() {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();

  return useMutation(
    async (ticketId) => {
      const res = await privateFetch.delete(`/v1/admin/podcast/support/ticket/${ticketId}`);
      return res.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('podcast-tickets');
      },
    }
  );
}

export default useDeletePodcastTicket;
